import * as styles from "../styles"
import { useDateTime } from "../utils"
import {Column, Row} from "./layout"


export const AgendaSidebar = ({agenda}) => {
	const now = useDateTime()

	const events = agenda
	const baseStyle = {
		...styles.fr,
		padding: "10px 0px 10px 5px",
		width: "100%",
		alignItems: "flex-start",
		textDecoration: "none",
		fontSize: "0.55vw",
		marginBottom: "10px",
		lineHeight: 1.2,
	}
	const rowStyles = [
		{
			...baseStyle,
			color: "#888",
		},{
			...baseStyle,
			fontWeight: "bold",
			color: "#3c1d4a",
		},{
			...baseStyle,
			color: "#3c1d4a",
		}
	]

	const isPastPresentFuture = (event, i, arr) => {
		const start = new Date(event.start)
		const end = new Date(event.end)
		const farEnd = new Date(new Date(event.end).valueOf() + 7200000)
		if (now > farEnd) return {
			...event,
			style: {display: "none"},
		}
		if (now > end) return {
			...event,
			style: rowStyles[0]
		}
		else if (now > start && now < end) return {...event, style: rowStyles[1]}
		else if (now < start) return {...event, start, end, style: rowStyles[2]}
	}

	return <Column class="breakout-agenda" styleOverride={{
		overflowX: "hidden",
		overflowY: "auto",
		scrollbarWidth: "none",
		maxHeight: "100%",
		height: "100%"
	}}>
		{events.map(it => isPastPresentFuture(it)).map(event => {
			try {
			const start = new Date(event.start)
			return <Row styleOverride={event.style}>
				<span class="agenda-time" style={{textAlign: "left", padding: "0"}}>
					{start.getHours().toString().padStart(2, "0")}:{start.getMinutes().toString().padStart(2, "0")}
				</span>
				<span class="agenda-item" style={{marginLeft: "10px", marginRight: "5px", textAlign: "left"}}>
					{event.title}
				</span>
			</Row>
		} catch(err) {
			return <></>
		}
		})}
	</Column>
}